/* eslint-disable react/no-array-index-key */
/* eslint-disable radix */
/* eslint-disable react/prop-types */
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from 'reactstrap';
import {
  addMenuSubMenuID,
  addModuloSubMenuID,
  addSubMenuID,
} from '~/store/modules/SubMenu/actions';
import { handeGetMenusData, handleGetSubMenus } from '../../SubMenuServices';
import { Container } from './styles';

function Card({
  setForm,
  form,
  setLoading,
  setMenus,
  setModuloSelected,
  setParents,
  setMenuSelected,
  modulos,
  loading,
  menus,
  parents,
  moduloSelected,
  menuSelected,
  handleSubmit,
}) {
  const dispatch = useDispatch();
  return (
    <Container>
      <h1>Cadastrar Sub Menu</h1>
      <Form style={{ width: '100%' }}>
        {/* Modulo | Menu | Sub Menu */}
        <Row form>
          <Col md={6}>
            <FormGroup>
              <Label>Selecione o módulo para visualizar os menus</Label>
              <Input
                placeholder="Selecione..."
                type="select"
                // eslint-disable-next-line radix
                onChange={(e) => {
                  dispatch(addModuloSubMenuID(parseInt(e.target.value)));
                  handeGetMenusData(
                    e,
                    setLoading,
                    setMenus,
                    setModuloSelected,
                    setMenuSelected
                  );
                }}
                defaultValue=""
                required
              >
                <option value="" disabled>
                  Selecione...
                </option>
                {modulos.map((modulo, index) => (
                  <option key={index} value={modulo.id}>
                    {modulo.nome}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>Selecione o menu</Label>
              <Input
                disabled={!moduloSelected}
                placeholder="Selecione..."
                type="select"
                // eslint-disable-next-line radix
                onChange={(e) => {
                  dispatch(addMenuSubMenuID(parseInt(e.target.value)));
                  handleGetSubMenus(setLoading, setParents, setMenuSelected);
                }}
                defaultValue=""
                required
              >
                <option value="" disabled>
                  Selecione...
                </option>
                {menus.map((menu, index) => (
                  <option key={index} value={menu.id}>
                    {menu.nome}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>
                <span>(opcional)</span> Selecione o sub menu
              </Label>
              <Input
                placeholder="Selecione..."
                type="select"
                // eslint-disable-next-line radix
                onChange={(e) =>
                  dispatch(addSubMenuID(parseInt(e.target.value)))
                }
                defaultValue=""
                disabled={!menuSelected}
                required
              >
                <option value="" disabled>
                  Selecione...
                </option>
                {parents.map((parent, index) => (
                  <option key={index} value={parent.id}>
                    {parent.nome}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>
        {/* Nome | Descrição | Nome Imagem */}
        <Row
          form
          style={{ borderTop: '1px solid #babaca', paddingTop: '16px' }}
        >
          <Col md={4}>
            <FormGroup>
              <Label>Nome do sub menu</Label>
              <Input
                type="text"
                placeholder="Insira o nome do sub menu"
                maxLength={200}
                onChange={(e) => setForm({ ...form, nome: e.target.value })}
                disabled={!menuSelected}
                required
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>Descrição do sub menu</Label>
              <Input
                type="text"
                placeholder="Insira a descrição do sub menu"
                maxLength={500}
                disabled={!menuSelected}
                onChange={(e) =>
                  setForm({ ...form, descricao: e.target.value })
                }
                required
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>
                <span>(opcional)</span> Nome da imagem
              </Label>
              <Input
                type="text"
                placeholder="Insira o nome da imagem"
                disabled={!menuSelected}
                maxLength={1000}
                onChange={(e) =>
                  setForm({ ...form, nomeImagem: e.target.value })
                }
                required
              />
            </FormGroup>
          </Col>
        </Row>
        {/* TipoPagina | Rota | Ordem */}
        <Row form>
          <Col md={4}>
            <FormGroup>
              <Label>Selecione o tipo de página</Label>
              <Input
                placeholder="Selecione..."
                type="select"
                onChange={(e) =>
                  setForm({ ...form, tipoPagina: e.target.value })
                }
                defaultValue="DEFAULT"
                disabled={!menuSelected}
                required
              >
                <option value="DEFAULT" disabled>
                  Selecione...
                </option>
                <option value="M">Menu</option>
                <option value="O">Opção</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>Rota do sub menu</Label>
              <Input
                type="text"
                disabled={form.tipoPagina !== 'O'}
                placeholder="Insira a rota do sub menu"
                onChange={(e) => setForm({ ...form, url: e.target.value })}
                maxLength={1000}
                required
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label for="name">Ordem </Label>
              <Input
                type="number"
                name="ordem"
                placeholder="Insira a ordem númerica"
                id="ordem"
                max={1000}
                min={0}
                onChange={(e) =>
                  setForm({ ...form, ordem: parseInt(e.target.value) })
                }
                disabled={!menuSelected}
                required
              />
            </FormGroup>
          </Col>
        </Row>
        {/* Situacao cadastral | Relatorio | blank */}
        <Row form>
          <Col md={4}>
            <FormGroup tag="fieldset" disabled={!menuSelected}>
              <Label>Situação cadastral</Label>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="radio1"
                    onChange={() =>
                      setForm({ ...form, idSituacaoCadastral: 1 })
                    }
                  />
                  Ativo
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="radio1"
                    onChange={() =>
                      setForm({ ...form, idSituacaoCadastral: 2 })
                    }
                  />
                  Inativo
                </Label>
              </FormGroup>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label for="name">Relatório </Label>
              <Input
                type="number"
                name="ordem"
                id="ordem"
                placeholder="Insira o id do relatorio"
                max={1000}
                min={0}
                onChange={(e) =>
                  setForm({ ...form, idRelatorio: parseInt(e.target.value) })
                }
                disabled={!menuSelected}
                required
              />
            </FormGroup>
          </Col>
          <Col md={4} />
        </Row>
      </Form>
      {loading ? (
        <Button color="primary" disabled>
          <Spinner size="sm" color="#FFF" />
        </Button>
      ) : (
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={!menuSelected || !moduloSelected}
        >
          Cadastrar
        </Button>
      )}
    </Container>
  );
}

export default Card;
